module.exports = __webpack_public_path__ + "static/media/Redskins.68a84d4a.pdf";